export type ProductMatrixId = "agent" | "claw" | "builder";

export type ProductMatrixItem = {
  id: ProductMatrixId;
  tabLabel: string;
  name: string;
  subtitle: string;
  /** 配图要点，与界面中的图标一一对应 */
  highlights: readonly [string, string, string];
};

const MATRIX_IMAGE_FILES: Record<ProductMatrixId, string> = {
  agent: "3ChatAgent.png",
  claw: "3ChatClaw.png",
  builder: "3ChatBuilder.png",
};

/** 产品矩阵左侧示意大图（与 `public/images/product-matrix/` 下文件名对应） */
export function productMatrixImageSrc(id: ProductMatrixId): string {
  return `/images/product-matrix/${MATRIX_IMAGE_FILES[id]}`;
}

export const productMatrixImageAlt: Record<ProductMatrixId, string> = {
  agent: "3ChatAgent 控制台：会话收件箱与客户画像",
  claw: "3ChatClaw 公域线索与获客队列界面",
  builder: "3ChatBuilder 知识库与接待流程配置界面",
};

export const productMatrixItems: ProductMatrixItem[] = [
  {
    id: "builder",
    tabLabel: "Builder",
    name: "用自然语言，搭建企业专属 Agent",
    subtitle: "把业务目标、产品知识、销售 SOP 和真实对话交给 Builder，通过对话完成生成、训练、测试与上线准备",
    highlights: [
      "定义转化目标与人工边界",
      "沉淀知识、话术与销售 Playbook",
      "在沙盒中测试后决定上线",
    ],
  },
  {
    id: "agent",
    tabLabel: "Agent",
    name: "在真实对话中，持续推进销售下一步",
    subtitle: "Agent 不停留在答案生成，而是理解客户阶段、判断当前最优动作，并协同渠道、系统与人工完成推进",
    highlights: [
      "多模态理解与动态客户画像",
      "异议处理、推荐与持续跟进",
      "关键节点由销售直接接入",
    ],
  },
  // {
  //   id: "claw",
  //   tabLabel: "Evaluation",
  //   name: "让真实业务结果，反过来训练 Agent",
  //   subtitle: "Evaluation 结合对话、上下文、Agent 动作与最终结果，定位赢单、输单和流失节点，并生成可确认的优化建议",
  //   highlights: [
  //     "识别转化机会与知识缺口",
  //     "复盘决策、动作与人工接手时机",
  //     "确认建议后更新 Builder 策略",
  //   ],
  // },
];
